<template >
    <div class=""  v-if="pt640ListSize !=null " :style="htmlAlign">
        <template v-if="orderKakuteiFlg == 0">
            <!-- 受注未確定のデータがない場合なんもださないよ -->
        </template>
        <template v-else >
            <div v-html="htmlTxt">
            </div>
        </template>
    </div>
</template>
<script>
/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
// import $ from "jquery";
export default {
    /* 
    * Name of component
    */
    name: "PT640BannerHtmlParts",
    /* 
    * Get data from parent component
    */
    props: {
        partsNo: {
            type: Number
        },
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            pt640ListSize:null,
            pt640Init:{},
            listIdErr:[],
            pt640ReqModel:{
              partsNo: null
            },
            htmlTxt:null,
            scriptTxt: null,
            scriptUrl: null,
            htmlAlign:null,
            site: "",
            orderKakuteiFlg:0
        }
    },
    
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        // eslint-disable-next-line
        _this.pt640ReqModel.partsNo = _this.partsNo;
        if (_this.ptInitData){
            _this.pt640Init = _this.ptInitData;
            _this.pt640ListSize = _this.pt640Init.bannerInfo;
            _this.htmlTxt = _this.ptInitData.html;
            _this.scriptTxt = _this.ptInitData.scriptTxt;
            _this.scriptUrl = _this.ptInitData.scriptUrl;
            _this.orderKakuteiFlg = _this.ptInitData.orderKakuteiFlg;
                
            //insert script
            if(_this.scriptTxt && _this.scriptTxt != "") {
                var script = document.createElement('script');
                script.appendChild(document.createTextNode(_this.scriptTxt));
                document.body.appendChild(script);
            }

            if(_this.scriptUrl && _this.scriptUrl != "") {
                var lstScriptUrl = _this.scriptUrl.split(";");
                var src = "";
                for (var i = 0; i < lstScriptUrl.length; i++) {
                    src = lstScriptUrl[i];
                    if(src != "") {
                        var scriptUrl = document.createElement('script'); 
                        scriptUrl.setAttribute('src',src);
                        document.body.appendChild(scriptUrl);
                    }
                }
            }
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT640 + _this.$UrlConstants.DO_INIT ,_this.pt640ReqModel).then(function(response) {
                _this.pt640Init = response.data;
                _this.pt640ListSize = _this.pt640Init.bannerInfo;
                _this.htmlTxt = response.data.html;
                _this.scriptTxt = response.data.scriptTxt;
                _this.scriptUrl = response.data.scriptUrl;
                _this.orderKakuteiFlg = response.data.orderKakuteiFlg;
                    
                //insert script
                if(_this.scriptTxt && _this.scriptTxt != "") {
                    var script = document.createElement('script');
                    script.appendChild(document.createTextNode(_this.scriptTxt));
                    document.body.appendChild(script);
                }

                if(_this.scriptUrl && _this.scriptUrl != "") {
                    var lstScriptUrl = _this.scriptUrl.split(";");
                    var src = "";
                    for (var i = 0; i < lstScriptUrl.length; i++) {
                        src = lstScriptUrl[i];
                        if(src != "") {
                            var scriptUrl = document.createElement('script'); 
                            scriptUrl.setAttribute('src',src);
                            document.body.appendChild(scriptUrl);
                        }
                    }
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
    },

    methods: {
        selectLink: function(itemNo) {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG030, params: {pageNo: 3, sItemNo: itemNo}});
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
    }
}
</script>
